import { render } from "./VerifyDocumentData.vue?vue&type=template&id=d0ae379c&lang=true"
import script from "./VerifyDocumentData.vue?vue&type=script&lang=js"
export * from "./VerifyDocumentData.vue?vue&type=script&lang=js"

import "./VerifyDocumentData.vue?vue&type=style&index=0&id=d0ae379c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__